module.exports = __webpack_public_path__ + "static/media/job-ad.5aa47f12.jpg";